module.exports = __webpack_public_path__ + "static/media/99gal40.2d9f3ff5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal40.jpg
// module id = 393
// module chunks = 0